import type { ConstructorCollection, ConstructorValueData } from '@Pages/PageProduct';

export const filterFabricsByCollections = (
  fabricCollections: ConstructorCollection[],
  parameterValues: ConstructorValueData[],
): ConstructorCollection[] => {
  return fabricCollections
    .map((collection) => {
      const fabrics = parameterValues.filter((value) => value.tags.collectionId === collection.id);

      if (fabrics.length < 1) return;

      return {
        ...collection,
        fabrics,
      };
    })
    .filter(Boolean);
};

export default filterFabricsByCollections;
